import React from 'react';
import './Portfolio.css';
import { DATA } from './data';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <div className='container title__container title__portfolio'>
        <h5>My Recent Works</h5>
        <h2>Portfolio</h2>
      </div>
      <div className='container portfolio__container'>
        {DATA.map(
          ({ id, img, title, type, description, github, demo, demo_name }) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className='portfolio__t-div'>
                  <div className='portfolio__item-image'>
                    <img src={img} alt='' />
                  </div>
                  <div className='portfolio__item-title'>
                    <h3>{title}</h3>
                  </div>
                  <div className='portfolio__item-type'>
                    <h4>{type}</h4>
                  </div>
                  <div className='portfolio__item-desc'>
                    <h4>{description}</h4>
                  </div>
                </div>
                <div className='portfolio__b-div'>
                  <div className='portfolio__item-cta'>
                    <a href={github} className='btn' target='_blank'>
                      Github
                    </a>
                    <a href={demo} className='btn btn-primary' target='_blank'>
                      {demo_name}
                    </a>
                  </div>
                </div>
              </article>
            );
          }
        )}
      </div>
    </section>
  );
};

export default Portfolio;
